import React from 'react';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SessionTypeDetails } from 'PointOfSale/modules/common/constants';

const SessionHeader = ({ currentSelectedSession, onClose }) => {
  const label = get(SessionTypeDetails, [currentSelectedSession, 'label'], '');
  return (
    <div className="headerHeight">
      <div className="inlineBlockWithFloatLeft">
        <div className="inlineBlockWithFloatLeft">
          <Icon name="plus circle" size="big" />
        </div>
        <div className="displayInlineBlock">
          <span className="primaryLabel">Add</span>
          <br />
          <span className="secondaryLabel">Session</span>
        </div>
      </div>
      <div className="session-header-divider">|</div>
      <div className="sessionLabel">
        <span className="secondaryLabel">{label}</span>
      </div>
      <div className="closeIconCss cursorPointer" onClick={onClose}>
        <Icon name="close" />
      </div>
    </div>
  );
};

SessionHeader.propTypes = {
  currentSelectedSession: PropTypes.string,
};

export default SessionHeader;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptions/component/SessionHeader.js